import React, { useState, useEffect } from "react";
import { db, firebaseConfig } from "./firebase";
import { useNavigate } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, serverTimestamp, doc, setDoc, getDocs, deleteDoc, query, where, addDoc } from "firebase/firestore";

// Initialize a secondary Firebase app for creating users without signing out the admin
const secondaryApp = initializeApp(firebaseConfig, "SecondaryAuthApp");
const secondaryAuth = getAuth(secondaryApp);

export default function AddTherapist({ onBack }) {
      const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        qual: "",
        location: "",
        image: "",
        expertise: "",
        email: ""
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [therapists, setTherapists] = useState([]);
    const [editingId, setEditingId] = useState(null);

    const fetchTherapists = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "therapists"));
            const fetched = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));

            setTherapists(fetched);
        } catch (error) {
            console.error("Failed to fetch therapists:", error);
        }
    };
     console.log(therapists,"print therapist")

    useEffect(() => {
        fetchTherapists();
    }, []);

    const handleInput = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const expertiseArray = formData.expertise
                .split(",")
                .map(item => item.trim())
                .filter(item => item.length > 0);

            let therapistId = editingId;
            if (!therapistId) {
                therapistId = formData.email.split("@")[0].toLowerCase().replace(/[^a-z0-9]/g, "_");
            }

            const therapistData = {
                id: therapistId,
                name: formData.name,
                qual: formData.qual,
                location: formData.location,
                image: formData.image,
                expertise: expertiseArray,
                email: formData.email,
                createdAt: serverTimestamp()
            };

            await setDoc(doc(db, "therapists", therapistId), therapistData, { merge: true });

            // 🔐 Sync with Firebase Authentication (Only for new therapists)
            if (!editingId) {
                try {
                    // Create user in Firebase Auth with a default temporary password
                    // Users @nabi.health will still use Google login, but this record authorizes them.
                    await createUserWithEmailAndPassword(secondaryAuth, formData.email, "Nabi@123456");
                    await signOut(secondaryAuth); // Clear the secondary app session
                } catch (authErr) {
                    console.warn("Firebase Auth creation skipped (User may already exist or error):", authErr.message);
                }
            }

            // Sync with users collection to grant therapist role
            const userRef = collection(db, "users");
            const q = query(userRef, where("email", "==", formData.email));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                // Pre-provision user record so they have therapist role on first login
                await addDoc(userRef, {
                    uid: "", // Will be filled on first social login, or used as a placeholder
                    email: formData.email,
                    name: formData.name,
                    role: "therapist",
                    createdAt: serverTimestamp()
                });
            } else {
                // Update existing user role if they already exist
                const userDoc = querySnapshot.docs[0];
                await setDoc(doc(db, "users", userDoc.id), { role: "therapist" }, { merge: true });
            }

            if (editingId) {
                setMessage("Therapist successfully updated!");
            } else {
                setMessage("Therapist successfully added!");
            }
            
            cancelEdit();
            fetchTherapists(); 
        } catch (error) {
            console.error("Error saving therapist:", error);
            setMessage("Failed to save therapist: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (t) => {
        setEditingId(t.id);
        setFormData({
            name: t.name || "",
            qual: t.qual || "",
            location: t.location || "",
            image: t.image || "",
            expertise: t.expertise ? t.expertise.join(", ") : "",
            email: t.email || ""
        });
        setMessage("Editing therapist: " + t.name);
    };

    const handleDelete = async (t) => {
        if (!window.confirm("Are you sure you want to delete " + t.name + "?")) return;
        try {
            await deleteDoc(doc(db, "therapists", t.id));
            setMessage("Therapist deleted.");
            fetchTherapists();
        } catch (error) {
            console.error("Error deleting:", error);
            setMessage("Failed to delete.");
        }
    };

    const cancelEdit = () => {
        setEditingId(null);
        setFormData({ name: "", qual: "", location: "", image: "", expertise: "", email: "" });
        setMessage("");
    };

    const styles = {
        container: { padding: '80px 40px', maxWidth: '1200px', margin: '0 auto', fontFamily: "'Syne', sans-serif" },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' },
        title: { fontSize: '2.5rem', fontWeight: '400', fontFamily: "'Syne', sans-serif", color: '#003049' },
        backBtn: { padding: '10px 20px', cursor: 'pointer', border: '1px solid #003049', color: '#003049', borderRadius: '30px', background: 'transparent', fontWeight: 'bold' },
        
        mainFlex: { display: 'flex', gap: '40px', alignItems: 'flex-start', flexWrap: 'wrap' },
        formSection: { flex: 1, minWidth: '400px', background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' },
        listSection: { flex: 1, minWidth: '400px', padding: '10px', height: '650px', overflowY: 'auto' },

        inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '15px' },
        label: { fontSize: '14px', fontWeight: '600', color: '#003049' },
        input: { padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: "'Syne', sans-serif", outline: 'none' },
        submitBtn: { padding: '15px', background: '#F07167', color: 'white', borderRadius: '30px', cursor: 'pointer', border: 'none', fontWeight: 'bold', fontSize: '16px', width: '100%', marginTop: '10px', boxShadow: '0 4px 15px rgba(240,113,103,0.3)' },
        
        msg: { padding: '15px', background: '#eefbf3', color: '#155724', borderRadius: '8px', marginBottom: '20px', border: '1px solid #c8e6c9', fontSize: '14px' },
        errorMsg: { padding: '15px', background: '#faeced', color: '#721c24', borderRadius: '8px', marginBottom: '20px', border: '1px solid #f5c6cb', fontSize: '14px' },
        
        listTitle: { fontSize: '1.5rem', fontWeight: '400', fontFamily: "'Syne', sans-serif", color: '#003049', marginBottom: '20px' },
        therapistCard: { padding: '20px', border: 'none', borderRadius: '15px', marginBottom: '15px', background: 'white', display: 'flex', gap: '20px', alignItems: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', position: 'relative' },
        therapistImg: { width: '70px', height: '70px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #FFF7F1', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' },
        therapistInfo: { flex: 1 },
        therapistName: { margin: '0 0 5px 0', fontSize: '18px', fontWeight: '600', color: '#003049', paddingRight: '60px' }, // Add padding to avoid overlapping icons
        therapistDetails: { margin: '0', fontSize: '13px', color: '#666', lineHeight: '1.6' },
        cardActions: { position: 'absolute', top: '20px', right: '20px', display: 'flex', flexDirection: 'row', gap: '10px' },
        actionBtn: { padding: '6px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#003049', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s' },
        deleteBtn: { padding: '6px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#F07167', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s' }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={styles.title}>{editingId ? "Edit Therapist" : "Add New Therapist"}</h1>
            </div>

            <div style={styles.mainFlex}>
                {/* LEFT: FORM */}
                <div style={styles.formSection}>
                    {message && (
                        <div style={message.includes("Failed") ? styles.errorMsg : styles.msg}>
                            {message}
                        </div>
                    )}

                    <div style={{ ...styles.msg, background: '#e3f2fd', borderColor: '#bbdefb', color: '#0d47a1', marginBottom: '20px' }}>
                        <strong>Note:</strong> To provide a therapist with an inbox (@nabi.health), please create the account in your <strong>Google Admin Console</strong> first. Then, they should use "Continue with Google" to log in.
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Name</label>
                            <input name="name" value={formData.name} onChange={handleInput} style={styles.input} required placeholder="Dr. John Doe" />
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Qualifications</label>
                            <input name="qual" value={formData.qual} onChange={handleInput} style={styles.input} placeholder="Ph.D in Clinical Psychology" />
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Location</label>
                            <input name="location" value={formData.location} onChange={handleInput} style={styles.input} placeholder="Mumbai" />
                        </div>
                        {/* <div style={styles.inputGroup}>
                            <label style={styles.label}>Image URL / Path</label>
                            <input name="image" value={formData.image} onChange={handleInput} style={styles.input} placeholder="/Nabi UI Assets/Assets_Images/Image.jpg" />
                        </div> */}
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Expertise (Comma separated)</label>
                            <input name="expertise" value={formData.expertise} onChange={handleInput} style={styles.input} placeholder="CBT, Anxiety Management, Depression" />
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Email</label>
                            <input name="email" value={formData.email} onChange={handleInput} style={styles.input} type="email" required placeholder="john@nabi.health" />
                        </div>

                        <div style={{display: 'flex', gap: '10px'}}>
                            <button type="submit" style={styles.submitBtn} disabled={loading}>
                                {loading ? "Saving..." : (editingId ? "Update Therapist" : "Add Therapist")}
                            </button>
                            {editingId && (
                                <button type="button" onClick={cancelEdit} style={{...styles.submitBtn, background: '#eee', color: '#333', boxShadow: 'none'}}>
                                    Cancel
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                {/* RIGHT: LIST */}
                <div className="no-scrollbar" style={styles.listSection}>
                    <h2 style={styles.listTitle}>Live Therapists ({therapists.length})</h2>
                    {therapists.length === 0 ? (
                        <p style={{ fontSize: '14px', color: '#777' }}>No dynamic therapists found.</p>
                    ) : (
                        therapists.map(t => (
                            <div key={t.id} style={styles.therapistCard}>
                                <img src={t.image || "/placeholder.jpg"} alt={t.name} style={styles.therapistImg} />
                                <div style={styles.therapistInfo}>
                                    <h3 style={styles.therapistName}>{t.name}</h3>
                                    <p style={styles.therapistDetails}>
                                        <strong style={{color:'#F07167'}}>ID/Email:</strong> {t.id} | {t.email} <br />
                                        <strong>Qual:</strong> {t.qual} | <strong>Location:</strong> {t.location} <br />
                                        <strong>Expertise:</strong> {t.expertise?.join(", ") || "N/A"}
                                    </p>
                                </div>
                                <div style={styles.cardActions}>
                                    <button onClick={() => handleEdit(t)} style={styles.actionBtn} title="Edit Therapist">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M12 20h9"></path>
                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                        </svg>
                                    </button>
                                    <button onClick={() => handleDelete(t)} style={styles.deleteBtn} title="Delete Therapist">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="3 6 5 6 21 6"></polyline>
                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
